import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface DevRuntimeState {
  /**
   * Override for tile images usage.
   * null = use env/default behavior
   * true = force enable tile images
   * false = force disable tile images
   */
  useTileImagesOverride: boolean | null;
  setUseTileImagesOverride: (value: boolean | null) => void;
}

export const useDevRuntimeStore = create<DevRuntimeState>()(
  persist(
    (set) => ({
      useTileImagesOverride: null,
      setUseTileImagesOverride: (value) => set({ useTileImagesOverride: value }),
    }),
    {
      name: 'castle-survivors-dev-runtime',
      storage: createJSONStorage(() => localStorage),
      skipHydration: false,
    }
  )
);
